const defaultOptions = { top: 0, behavior: 'smooth' }

export const scrollWindowToPosition = options => {
	window.scroll({ ...defaultOptions, ...options })
}
